type KeywordGroup = {
  key: string;
  variants: string[];
};

const KEYWORD_GROUPS: KeywordGroup[] = [
  {
    key: 'HDM',
    variants: ['ՀԴՄ', 'cash register device'],
  },
  {
    key: 'SOFT_POS',
    variants: ['Soft POS', 'SoftPOS'],
  },
  {
    key: 'LINKPAY',
    variants: ['LinkPay'],
  },
  {
    key: 'ECOMMERCE',
    variants: ['E-Commerce', 'ECommerce', 'ecommerce'],
  },
  {
    key: 'POS',
    variants: ['POS'],
  },
];

function normalize(str: string): string {
  return str.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');
}

export function getMatchingServiceOption(
  title: string,
  options: string[],
): string | null {
  const normalizedTitle = normalize(title);

  const matchedGroup = KEYWORD_GROUPS.find((group) =>
    group.variants.some((variant) =>
      normalizedTitle.includes(normalize(variant)),
    ),
  );

  if (!matchedGroup) return null;

  return (
    options.find((option) =>
      matchedGroup.variants.some((variant) =>
        normalize(option).includes(normalize(variant)),
      ),
    ) || null
  );
}
